interface FormFooterProps {
  children: React.ReactNode;
}

export function FormFooter({ children }: FormFooterProps) {
  return (
    <div
      data-form-footer
      className="sticky bottom-0 -mx-6 -mb-6 mt-auto flex justify-between bg-white border-t border-gray-200 px-6 py-4 z-20"
    >
      {children}
    </div>
  );
}
